import type { Icon } from '../../../src/lib/types'
export const mdiArrowExpandHorizontal: Icon = {
  "id": "arrow-expand-horizontal",
  "name": "Arrow Expand Horizontal",
  "path": "M9,11H15V8L19,12L15,16V13H9V16L5,12L9,8V11M2,20V4H4V20H2M20,20V4H22V20H20Z",
  "as": [],
  "tags": [
    "Arrow"
  ]
}
export default mdiArrowExpandHorizontal